import { _genId } from '@ifr/form-questionnaire';
import { defineStore } from 'pinia';

type TColor = 'success' | 'info' | 'warning' | 'error';

export interface IMessage {
  message: string;
  color?: TColor | string;
  daley?: number;
  manual?: boolean;
  icon?: string;
}

interface IMessageSys extends IMessage {
  key: string;
}

interface IMessageStore {
  storeSuccess0: IMessageSys[];
}

export const useSuccessStore = defineStore('success', {
  state: (): IMessageStore => ({
    storeSuccess0: [],
  }),

  getters: {
    storeSuccess: (state) => state.storeSuccess0,
  },

  actions: {
    clearAllSuccess() {
      this.storeSuccess0 = [];
    },

    removeSuccess(i = 0) {
      if (i < this.storeSuccess.length) {
        this.storeSuccess.splice(i, 1);
      }
    },

    addSuccessItem(
      item: IMessageSys = { key: '0', message: '', daley: 3000, color: 'success', icon: 'mdi-check-circle' },
    ) {
      this.storeSuccess.push(item);
    },

    addSuccess(
      {
        message = 'Успешно сохранено!',
        daley = 3000,
        color = 'success',
        manual = false,
        icon = 'mdi-check-circle',
      }: IMessage = {} as IMessage,
    ) {
      const key = _genId();
      this.addSuccessItem({ message, key, color, icon } as IMessageSys);

      if (manual) {
        return;
      }

      setTimeout(() => {
        let j = 0;
        const res = this.storeSuccess.find((item, i) => {
          j = i;
          return item.key === key;
        });
        if (res) {
          this.removeSuccess(j);
        }
      }, daley);
    },
  },
});

export default useSuccessStore;
